module.exports = __webpack_public_path__ + "img/38.848f517d.png";